import { render, staticRenderFns } from "./FeaturesPage.vue?vue&type=template&id=3ec1ca86&"
import script from "./FeaturesPage.vue?vue&type=script&lang=ts&"
export * from "./FeaturesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports